// Module
var code = `<ng-form name="\$ctrl.form">
  <div class="form-column">
    <form-section form-title="'Company data'">
      <form-section-field field-title="'Business name'" ng-if="\$ctrl.cfg.visible('customer', 'corporate', 'business_name')">
        <textarea ng-model="\$ctrl.profile.corporateData.businessName"
                  ng-disabled="!\$ctrl.editMode"
                  ng-required="\$ctrl.cfg.required('customer', 'corporate', 'business_name')"
                  ng-change="\$ctrl.nameChanged()"
                  id="cpr_business_name"
                  maxlength="255"
                  rows="4"
                  placeholder="Name"
                  data-toggle="tooltip"
                  title="Business name"></textarea>
      </form-section-field>
      <button ng-if="\$ctrl.shouldDisplayRiskProfiling"
              class="btn btn-primary pull-right watchlist-button"
              ng-disabled="!\$ctrl.profile.corporateData.businessName || \$ctrl.verifyDone || !\$ctrl.editMode"
              ng-click="\$ctrl.watchlistVerify(\$event)">
        Watchlist verify
      </button>
      <form-section-field field-title="'Trade name'" ng-if="\$ctrl.cfg.visible('customer', 'corporate', 'trade_name')">
        <textarea ng-model="\$ctrl.profile.corporateData.tradeName"
                  ng-disabled="!\$ctrl.editMode"
                  ng-required="\$ctrl.cfg.required('customer', 'corporate', 'trade_name')"
                  id="cpr_trade_name"
                  maxlength="255"
                  rows="4"
                  placeholder="Trade name"
                  data-toggle="tooltip"
                  title="Trade name"></textarea>
      </form-section-field>
      <form-section-field field-title="'Business Type'" ng-if="\$ctrl.cfg.visible('customer', 'corporate', 'business_type')">
        <select ng-model="\$ctrl.profile.corporateData.businessTypeId"
                ng-disabled="!\$ctrl.editMode"
                ng-required="\$ctrl.cfg.required('customer', 'corporate', 'business_type')"
                ng-change="\$ctrl.businessTypeChanged()"
                id="cpr_business_type"
                ng-options="entry.id as entry.description for entry in \$ctrl.dict.BUSINESS_TYPE">
        </select>
      </form-section-field>
      <form-section-field field-title="'Conglomerate'" ng-if="\$ctrl.isCorporationBusinessType() && \$ctrl.cfg.visible('customer', 'corporate', 'conglomerate')">
        <select ng-model="\$ctrl.profile.corporateData.conglomerateId"
                ng-disabled="!\$ctrl.editMode"
                ng-required="\$ctrl.cfg.required('customer', 'corporate', 'conglomerate')"
                id="cpr_conglomerate"
                ng-options="entry.id as entry.description for entry in \$ctrl.dict.CONGLOMERATE">
        </select>
      </form-section-field>
      <form-section-field field-title="'Source of Funds'" ng-if="\$ctrl.cfg.visible('customer', 'corporate', 'source_of_funds')">
        <input ng-model="\$ctrl.profile.corporateData.sourceOfFunds"
               ng-disabled="!\$ctrl.editMode"
               ng-required="\$ctrl.cfg.required('customer', 'corporate', 'source_of_funds')"
               type="text"
               id="cpr_source_of_funds"
               placeholder="Source of Funds"
               maxlength="64">
      </form-section-field>
      <form-section-field field-title="'Firm Size'">
        <select id="cpr_firm_size"
                disabled
                ng-model="\$ctrl.profile.corporateData.firmSizeId"
                ng-options="entry.id as entry.description for entry in \$ctrl.dict.FIRM_SIZE | orderBy:'id'">"
          <option></option>
        </select>
      </form-section-field>
      <form-section-field field-title="'Place of Incorporation'" ng-if="\$ctrl.cfg.visible('customer', 'corporate', 'place_of_incorporation')">
        <input ng-model="\$ctrl.profile.corporateData.placeOfIncorporation"
               ng-disabled="!\$ctrl.editMode"
               ng-required="\$ctrl.cfg.required('customer', 'corporate', 'place_of_incorporation')"
               type="text"
               id="cpr_place_of_incorporation"
               placeholder="Place of Incorporation"
               maxlength="64">
      </form-section-field>
      <form-section-field field-title="'Registration Date'" ng-if="\$ctrl.cfg.visible('customer', 'corporate', 'registration_date')">
        <date output-format="date"
          ng-disabled="!\$ctrl.editMode"
          ng-required="\$ctrl.cfg.required('customer', 'corporate', 'registration_date')"
          validate-date="lte:posting-date"
          id="cpr_registration_date"
          ng-model="\$ctrl.profile.corporateData.registrationDate"></date>
      </form-section-field>
      <form-section-field field-title="'Registration Number'" ng-if="\$ctrl.cfg.visible('customer', 'corporate', 'registration_number')">
        <input ng-model="\$ctrl.profile.corporateData.registrationNumber"
               ng-pattern="/^[0-9a-zA-Z_-]+\$/"
               ng-required="\$ctrl.cfg.required('customer', 'corporate', 'registration_number')"
               maxlength="64"
               ng-disabled="!\$ctrl.editMode"
               type="text"
               placeholder="Registration number">
      </form-section-field>
      <form-section-field field-title="'Registration Country'" ng-if="\$ctrl.cfg.visible('customer', 'corporate', 'registration_country')">
        <select ng-required="\$ctrl.cfg.required('customer', 'corporate', 'registration_country')"
                ng-model="\$ctrl.profile.corporateData.registrationCountryId"
                ng-disabled="!\$ctrl.editMode"
                id="cpr_registration_country"
                ng-options="entry.id as entry.description for entry in \$ctrl.dict.COUNTRY">
          <option></option>
        </select>
      </form-section-field>
    </form-section>
  </div>

  <div class="form-column">
    <form-section form-title="'Contact data'" ng-if="\$ctrl.cfg.visible('customer', 'corporate', 'email') || \$ctrl.cfg.visible('customer', 'corporate', 'work_number')">
      <form-section-field field-title="'Email'" ng-if="\$ctrl.cfg.visible('customer', 'corporate', 'email')">
        <input ng-model="\$ctrl.profile.corporateData.email"
               ng-disabled="!\$ctrl.editMode"
               ng-required="\$ctrl.cfg.required('customer', 'corporate', 'email')"
               type="email"
               id="cpr_corporate_email"
               placeholder="Email Address"
               maxlength="64">
      </form-section-field>
      <form-section-field field-title="'Phone number'" ng-if="\$ctrl.cfg.visible('customer', 'corporate', 'work_number')">
        <telephone ng-model="\$ctrl.profile.extractedPhones.work.number"
                   ng-disabled="!\$ctrl.editMode"
                   ng-required="\$ctrl.cfg.required('customer', 'corporate', 'work_number')"
                   id="cpr_corp_phone_number"></telephone>
      </form-section-field>
    </form-section>

    <form-section form-title="'Compliance'" ng-if="\$ctrl.cfg.visible('customer', 'corporate', 'risk_level')">
      <form-section-field field-title="'Risk Level'" ng-if="\$ctrl.cfg.visible('customer', 'corporate', 'risk_level')">
        <select ng-model="\$ctrl.profile.corporateData.riskLevelId"
                ng-disabled="!\$ctrl.editMode"
                ng-required="\$ctrl.cfg.required('customer', 'corporate', 'risk_level')"
                id="cpr_risk_level"
                ng-options="entry.id as entry.description for entry in \$ctrl.dict.CUSTOMER_RISK_LEVEL">
          <option></option>
        </select>
      </form-section-field>
      <form-section-field field-title="'Average monthly deposit amount'" ng-if="\$ctrl.cfg.visible('customer', 'corporate', 'expected_monthly_transaction')">
        <compliance-non-commensurate-select ng-required="\$ctrl.cfg.required('customer', 'corporate', 'expected_monthly_transaction')"
                                            ng-model="\$ctrl.profile.corporateData.expectedMonthlyTransactionId"
                                            customer-type="\$ctrl.profile.customerType"
                                            customer-subtype="\$ctrl.profile.customerSubtype"
                                            ng-disabled="!\$ctrl.editMode"
                                            id="cpr_expected_monthly_transaction">
        </compliance-non-commensurate-select>
      </form-section-field>

      <form-section-field field-title="'DOSRI'" ng-if="\$ctrl.cfg.visible('customer', 'corporate', 'dosri')">
        <select ng-required="\$ctrl.cfg.required('customer', 'corporate', 'dosri')"
                ng-model="\$ctrl.profile.dosri"
                ng-change="\$ctrl.dosriChanged()"
                ng-disabled="!\$ctrl.editMode"
                boolean-options>
        </select>
      </form-section-field>
      <form-section-field field-title="'DOSRI type'"
                          ng-if="\$ctrl.cfg.visible('customer', 'corporate', 'dosri') && \$ctrl.profile.dosri">
        <select ng-required="true"
                ng-model="\$ctrl.profile.dosriType"
                ng-disabled="!\$ctrl.editMode"
                ng-options="dosriType | prettyEnum for dosriType in \$ctrl.dosriTypes">>
        </select>
      </form-section-field>
      <form-section-field field-title="'Related Party Transaction'" ng-if="\$ctrl.cfg.visible('customer', 'compliance', 'related_party_transaction')">
        <select ng-required="\$ctrl.cfg.required('customer', 'compliance', 'related_party_transaction')"
                ng-model="\$ctrl.profile.corporateData.relatedPartyTransaction"
                ng-change="\$ctrl.rptChanged()"
                ng-disabled="!\$ctrl.editMode"
                ng-options="entry.value as entry.label | prettyEnum for entry in \$ctrl.relatedPartyTransactions">
          <option value="">Not rpt</option>
        </select>
      </form-section-field>
      <form-section-field field-title="'Related Party Transaction Description'"
                          ng-if="\$ctrl.profile.corporateData.relatedPartyTransaction === 'OTHERS'">
        <input ng-required="true"
               ng-model="\$ctrl.profile.corporateData.relatedPartyTransactionDescription"
               type="text"
               ng-disabled="!\$ctrl.editMode"
               maxlength="128">
      </form-section-field>

      <form-section-field field-title="'Sanctioned entity:'" ng-if="\$ctrl.cfg.visible('customer', 'compliance', 'sanctioned_entity')">
        <select ng-required="\$ctrl.cfg.required('customer', 'compliance', 'sanctioned_entity')"
                ng-model="\$ctrl.profile.corporateData.sanctionedEntity"
                ng-disabled="!\$ctrl.editMode || !\$ctrl.shouldDisplayRiskProfiling"
                boolean-options>
        </select>
      </form-section-field>

      <form-section-field field-title="'Signature upload'"
                          ng-if="\$ctrl.cfg.visible('customer', 'compliance', 'signature_upload')">
        <file-id-upload ng-model="\$ctrl.profile.corporateData.signatureFileId"
                     ng-required="\$ctrl.cfg.required('customer', 'compliance', 'signature_upload')"
                     max-files="1"
                     name="signature_upload"
                     ng-disabled="!\$ctrl.editMode"
                     show-file-name="false"
                     single-file="true"
                     show-remarks="false"
        >
        </file-id-upload>
      </form-section-field>
      <form-section-field field-title="'Picture upload'"
                          ng-if="\$ctrl.cfg.visible('customer', 'compliance', 'picture_upload')">
        <file-id-upload ng-model="\$ctrl.profile.pictureFileId"
                     ng-required="\$ctrl.cfg.required('customer', 'compliance', 'picture_upload')"
                     max-files="1"
                     max-size="'512KB'"
                     name="picture_upload"
                     ng-disabled="!\$ctrl.editMode"
                     show-file-name="false"
                     single-file="true"
                     show-remarks="false"
        >
        </file-id-upload>
      </form-section-field>
    </form-section>

    <form-section form-title="'Other'">
      <form-section-field field-title="'Comments'" ng-if="\$ctrl.cfg.visible('customer', 'other_data', 'comments')">
        <textarea ng-required="\$ctrl.cfg.required('customer', 'other_data', 'comments')"
                  ng-model="\$ctrl.profile.comments"
                  ng-disabled="!\$ctrl.editMode"
                  id="cpr_other_data_comments"
                  rows="6"
                  maxlength="1024">
        </textarea>
      </form-section-field>
    </form-section>
  </div>

  <div class="clearfix"></div>

</ng-form>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/shared/customer-profile-commons/corporate-data.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;